/**
 * CEL language services for Monaco editor.
 *
 * Provides schema-aware autocomplete, hover tooltips, and signature help
 * for Common Expression Language (CEL) expressions.
 *
 * @module cel
 *
 * @example
 * ```ts
 * import {
 *   makeCELCompletionProvider,
 *   makeCELHoverProvider,
 *   makeCELSignatureHelpProvider,
 * } from 'components/core/editor/cel'
 *
 * // Register providers with Monaco
 * monaco.languages.registerHoverProvider('cel', makeCELHoverProvider(schemaRegistry))
 * monaco.languages.registerSignatureHelpProvider('cel', makeCELSignatureHelpProvider(schemaRegistry))
 * monaco.languages.registerCompletionItemProvider('cel', makeCELCompletionProvider(...))
 * ```
 */

export { makeCELCompletionProvider } from './completionProvider'
export { makeCELHoverProvider } from './hoverProvider'
export { makeCELSignatureHelpProvider } from './signatureProvider'
export type { SchemaRegistry } from './types'
export { parseExpressionContext } from './utils'
